import AxiosService from './AxiosService'

class RoleRestService {
  get(): Promise<any> {
    return AxiosService.get('/roles')
  }

  create(role: any): Promise<any> {
    return AxiosService.post('/roles/', role)
  }

  update(role: any): Promise<any> {
    return AxiosService.put('/roles/' + role.id, role)
  }

  delete(id: number): Promise<any> {
    return AxiosService.delete('/roles/' + id)
  }

  getAssignedPermissions(id: number): Promise<any> {
    return AxiosService.get('/roles/' + id + '/permissions/')
  }

  updateAssignedPermissions(id: number, permissions: number[]): Promise<any> {
    return AxiosService.put('/roles/' + id + '/permissions/', permissions)
  }
}

export default new RoleRestService()
